var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExploreBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.576,
    height: 68.928,
    viewBox: "0 0 67.576 68.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "strategy-development",
    transform: "translate(-1.47 -0.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46629",
    "data-name": "Group 46629",
    transform: "translate(1.47 0.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54099",
    "data-name": "Path 54099",
    d: "M69.023,52.507l-.014,5.212a.82.82,0,0,1-.072.345.4.4,0,0,1-.187.215l-3,1.752A.052.052,0,0,1,65.764,60a.57.57,0,0,1-.632-.043L54,53.541l-.014,1.149a.993.993,0,0,1-.56.79L48.819,58.15a3.039,3.039,0,0,1-2.728,0l-4.983-2.872-9.363,5.442-5,7.166-5.2-1.235-2.685,1.566L12.4,64.483,4.017,62.5l1.422-2.039L1.475,58.179l9.391-5.471,5.026-7.165,5.2,1.221,2.685-1.551,6.419,3.7,2.829.675v-.718a.956.956,0,0,1,.56-.79l3.891-2.255V43.992l-4.121-2.369A5.339,5.339,0,0,1,31.2,44.107l-1.493.862.23-.187c-1.852,1.407-4.6,1.393-7.654-.374a20.263,20.263,0,0,1-6.821-7.022L8.3,41.522,7,44.222,1.891,47.18l1.637-3.432L1.877,42.24l5.112-2.957L8.3,40.459,15,36.6A20.159,20.159,0,0,1,12.23,26.99c.014-3.217,1.163-5.471,3.016-6.505l1.666-.976c1.824-1.063,4.365-.919,7.18.7.172.1.345.23.531.33l.043-16.47a1.325,1.325,0,0,1,.46-1.12l.029-.029c.043-.029.086-.043.129-.072l2.9-1.723a1.29,1.29,0,0,1,1.321.13L67.2,23.026a4.085,4.085,0,0,1,1.838,3.217L68.98,52.507h.043Z",
    transform: "translate(-1.468 -0.999)",
    fill: "#e4e8f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54100",
    "data-name": "Path 54100",
    d: "M39.842,52.887,48.6,47.8l0-.659h0l0-.653h0l0-.653h0l0-.653-8.817-5.09-8.759,5.09,0,.659h0l0,.653h0l0,.653h0l0,.653Z",
    transform: "translate(11.415 16.041)",
    fill: "#e4e8f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46628",
    "data-name": "Group 46628",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46537",
    "data-name": "Group 46537",
    transform: "translate(23.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46535",
    "data-name": "Group 46535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46528",
    "data-name": "Group 46528",
    transform: "translate(8.44 38.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46522",
    "data-name": "Group 46522",
    transform: "translate(0 5.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46521",
    "data-name": "Group 46521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46519",
    "data-name": "Group 46519",
    transform: "translate(0 3.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54101",
    "data-name": "Path 54101",
    d: "M44.422,38.885l-.008,1.265a.976.976,0,0,1-.566.791l-4.6,2.677a3.038,3.038,0,0,1-2.739,0L24.015,36.41a.987.987,0,0,1-.574-.807l.008-1.265a.976.976,0,0,0,.566.807l12.493,7.208a3.04,3.04,0,0,0,2.739,0l4.609-2.677a.976.976,0,0,0,.566-.791Z",
    transform: "translate(-23.441 -34.338)",
    fill: "#474b59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46520",
    "data-name": "Group 46520",
    transform: "translate(0.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54102",
    "data-name": "Path 54102",
    d: "M43.85,39.237a.838.838,0,0,1,0,1.587L39.247,43.5a3.016,3.016,0,0,1-2.741,0L24.017,36.294a.84.84,0,0,1-.009-1.59l4.607-2.677a3.026,3.026,0,0,1,2.745,0Z",
    transform: "translate(-23.444 -31.697)",
    fill: "#5b5e71"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46527",
    "data-name": "Group 46527",
    transform: "translate(4.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46526",
    "data-name": "Group 46526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46523",
    "data-name": "Group 46523",
    transform: "translate(10.642 6.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54103",
    "data-name": "Path 54103",
    d: "M35.673,32.143l0,7.928-1.715,1,0-7.928Z",
    transform: "translate(-33.955 -32.143)",
    fill: "#bac1ce"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46524",
    "data-name": "Group 46524",
    transform: "translate(0 0.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54104",
    "data-name": "Path 54104",
    d: "M37.189,34.7l0,7.928L26.544,36.486l0-7.928Z",
    transform: "translate(-26.544 -28.558)",
    fill: "#d4dae8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46525",
    "data-name": "Group 46525",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54105",
    "data-name": "Path 54105",
    d: "M38.9,34.008l-1.715,1L26.546,28.86l1.715-1Z",
    transform: "translate(-26.546 -27.864)",
    fill: "#e4e8f4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46534",
    "data-name": "Group 46534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46529",
    "data-name": "Group 46529",
    transform: "translate(0 29.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54106",
    "data-name": "Path 54106",
    d: "M58.992,45.348l-.015,5.211a.8.8,0,0,1-.065.35c-.128.282-.438.354-.8.144L18.424,28.139a1.9,1.9,0,0,1-.789-1.062,1.433,1.433,0,0,1-.072-.428l.015-5.211Z",
    transform: "translate(-17.564 -21.438)",
    fill: "#e4e8f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46530",
    "data-name": "Group 46530",
    transform: "translate(41.167 51.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54107",
    "data-name": "Path 54107",
    d: "M49.506,36.873l-.014,5.21a.811.811,0,0,1-.071.342.4.4,0,0,1-.185.213l-3,1.751a.464.464,0,0,0,.185-.213.818.818,0,0,0,.057-.342l.014-5.209Z",
    transform: "translate(-46.232 -36.873)",
    fill: "#bac1ce"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46531",
    "data-name": "Group 46531",
    transform: "translate(1.538 3.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54108",
    "data-name": "Path 54108",
    d: "M57.092,25.638l-.071,24.927L18.634,28.4,18.7,3.475Z",
    transform: "translate(-18.634 -3.475)",
    fill: "#e4e8f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46532",
    "data-name": "Group 46532",
    transform: "translate(0.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54109",
    "data-name": "Path 54109",
    d: "M61.877,26.236l-.071,26.276-3.018,1.751.085-26.276a4.114,4.114,0,0,0-1.85-3.217L19.318,3.007a1.41,1.41,0,0,0-1.4-.036l3.1-1.843a1.3,1.3,0,0,1,1.324.128L60.027,23.02a4.113,4.113,0,0,1,1.85,3.217Z",
    transform: "translate(-17.915 -1)",
    fill: "#3f434f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46533",
    "data-name": "Group 46533",
    transform: "translate(0.015 1.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54110",
    "data-name": "Path 54110",
    d: "M57.214,24.24a4.081,4.081,0,0,1,1.848,3.211l-.074,26.274L17.574,29.815l.074-26.274c0-1.18.842-1.658,1.869-1.065Zm.27,26.87.071-24.927L19.167,4.021,19.1,28.948Z",
    transform: "translate(-17.574 -2.222)",
    fill: "#525566"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46536",
    "data-name": "Group 46536",
    transform: "translate(16.786 41.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54111",
    "data-name": "Path 54111",
    d: "M30.69,29.821a3.137,3.137,0,0,1,1.428,2.473c0,.919-.637,1.281-1.437.819a3.138,3.138,0,0,1-1.428-2.473c0-.906.649-1.274,1.437-.819Z",
    transform: "translate(-29.253 -29.626)",
    fill: "#bac1ce"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46571",
    "data-name": "Group 46571",
    transform: "translate(0 44.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46564",
    "data-name": "Group 46564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46538",
    "data-name": "Group 46538",
    transform: "translate(2.546 0.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54112",
    "data-name": "Path 54112",
    d: "M37.846,37.393,25.971,54.357,3.243,48.982,15.118,32.017Z",
    transform: "translate(-3.243 -32.017)",
    fill: "#cad0dd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46539",
    "data-name": "Group 46539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54113",
    "data-name": "Path 54113",
    d: "M41.165,41.832l-22.3,12.96L1.47,44.75l22.3-12.96Z",
    transform: "translate(-1.47 -31.79)",
    fill: "#e4e8f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46563",
    "data-name": "Group 46563",
    transform: "translate(2.512 8.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46562",
    "data-name": "Group 46562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46540",
    "data-name": "Group 46540",
    transform: "translate(2.999 2.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54114",
    "data-name": "Path 54114",
    d: "M9.923,41.944v.467H9.788l0-.281v-.107H9.734l-1.246.028-.216.005v-.022l0-.111L8.237,41.3l0-.1,0-.04-.005-.117L8.2,40.456l0-.1H5.313v-.13l0-.681V39.5l.126,0v.038l.01.678v.053H8.327l0,.1.033.741.005.117.032.722v.022l.152,0,1.051-.027.19,0Z",
    transform: "translate(-5.309 -39.501)",
    fill: "#ed435c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46541",
    "data-name": "Group 46541",
    transform: "translate(5.362 4.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54115",
    "data-name": "Path 54115",
    d: "M7.074,41.656h-.12v-.039l.6-.348v.022l.216-.005.625.361.646-.375-.025-.014h.051v.107l-.487.283-.368,0-.566-.327Z",
    transform: "translate(-6.954 -41.258)",
    fill: "#cad0dd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46542",
    "data-name": "Group 46542",
    transform: "translate(5.325 0.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54116",
    "data-name": "Path 54116",
    d: "M14.784,42.819l-.244.142-7.613-4.4.244-.142Z",
    transform: "translate(-6.928 -38.424)",
    fill: "#cad0dd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46543",
    "data-name": "Group 46543",
    transform: "translate(0 1.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54117",
    "data-name": "Path 54117",
    d: "M13.72,43.259l-.239.031-.478.28-.27-.156-.156.021.332.2-.27.156.218-.021L13,43.685l.1.062.166-.021-.177-.1Zm0,0-.239.031-.478.28-.27-.156-.156.021.332.2-.27.156.218-.021L13,43.685l.1.062.166-.021-.177-.1Zm0,0-.239.031-.478.28-.27-.156-.156.021.332.2-.27.156.218-.021L13,43.685l.1.062.166-.021-.177-.1Zm0,0-.239.031-.478.28-.27-.156-.156.021.332.2-.27.156.218-.021L13,43.685l.1.062.166-.021-.177-.1Zm0,0-.239.031-.478.28-.27-.156-.156.021.332.2-.27.156.218-.021L13,43.685l.1.062.166-.021-.177-.1Zm1.61-.062-.093-.062-.654-.374-.094-.052-.654-.374-.093-.062-.654-.374-.094-.052-.654-.374-.093-.062-.654-.374-.094-.052-.644-.374-.093-.052-.654-.384-.094-.052-.665-.384-.093-.052-.644-.374-.094-.052-.748-.436-.748.436-.093.052-.644.374-.094.062-.654.374-.083.052-.654.384-.093.052L4.04,41h.187l.571-.333L5.38,41h.228l-.01.135.6.343-.6.353-.021.011h.166l.54-.312.561.322h.187l-.654-.374.654-.384.654.384-.644.374h.177l.561-.322.582.333h.228v.135l.592.343-.01-.115-.55-.322.53-.3-.01-.1-.613.353-.654-.374.644-.374.623.353v-.114l-.519-.3.488-.28v-.114l-.582.342-.582-.342H7.613l-.582.342-.582-.342H6.221v-.125l-.592-.343.592-.343V39.8h.125v.041l.592.333-.582.343v.052H6.45l.582-.332.582.332h.312l.592-.343.592.343h.125l.01.1.021-.011.654.374-.644.374.01.125.634.364-.6.353v.021h.145l.55-.322.509.3.187-.01-.6-.343.654-.374.654.374-.582.343v.187l.478.28.2-.011-.644-.363.644-.384.644.384-.634.363h.114v.042l.613-.353.665.374-.654.374-.623-.364-.01.114.54.312-.561.322.26-.042.395-.228.218.135.156-.031-.28-.156.644-.384.654.374h.042l.031.073.031-.01.644.374.042-.01.021.073.031-.01.654.384-.644.374-.654-.384.613-.364-.208.021-.5.291-.364-.207-.166.021.436.25L13,44.433l-.644-.374.343-.2-.218.021-.218.125-.156-.093-.166.01.229.135-.654.374-.654-.374.052-.031-.208.021v-.083l-.592-.343.592-.342L10.7,43.1l-.54-.311h-.27l-.613.353-.6-.353H8.454v-.125l-.571-.332L8.454,42V41.94H8.382l-.592.342-.613-.353-.27-.011-.613.353-.623-.353-.239-.01-.623.364L4.155,41.9l.654-.374.623.364.01-.1-.54-.311.571-.333v-.062H5.39l-.582.343-.6-.353H4.04V41l-.073.042-.748.436.748.426.094.052.654.384.093.052.654.374.094.052.654.384.093.052.654.374.094.052.654.384.093.052.644.374.094.052.654.384.093.052.665.374.083.062.654.374.093.052.748.436.748-.436.094-.052.644-.374.093-.062.654-.374.083-.052.654-.374.094-.062.644-.374.093-.052.748-.437ZM7.769,40.662l.654.374-.644.374-.654-.374Zm-1.475,0,.644.374-.654.384-.644-.384ZM6.2,40.611l-.654.374-.654-.374.644-.384Zm-2.794.862.654-.384.654.384-.654.374Zm8.859,2.638.644.374-.644.384-.654-.374Zm-.093.81-.644.374-.654-.374.644-.374Zm-1.4-.81.654.384-.644.374-.654-.384Zm-.093-.052-.644.374-.654-.384.644-.374Zm-.654-1.247.654.384-.654.374L9.368,43.2Zm-.094.81L9.285,44l-.654-.374.644-.374Zm-1.4-.81.654.384-.644.374L7.883,43.2Zm-.094-.052-.644.374-.644-.374.644-.374Zm-1.392-.81.654.384-.644.374-.665-.374Zm-2.14.384.644-.384.665.384-.654.374Zm.748.426.654-.374.654.374-.654.384Zm1.392.81L6.4,43.2l.654-.384L7.7,43.2Zm.093.052.654-.374.654.374-.644.384Zm.758.437.644-.384.654.374-.654.384Zm.737.425.654-.374.654.374-.654.384Zm.748.436.654-.384.654.384-.654.374Zm.748.426.654-.374.654.374-.654.384Zm1.4.81-.654-.374.654-.384.654.384Zm.748-.425-.654-.384.644-.374.654.374Zm.737-.437-.654-.374L13,44.537l.665.384Zm.737-.425-.654-.384.644-.374.665.384Zm-5.982-5.93.654.374-.654.384-.654-.384Zm-1.392.8.644-.374.654.384-.644.374Zm1.4.81-.654-.374.644-.374.654.374Zm.083-.8.654-.384.654.374-.654.384Zm.748.426.654-.374.654.374-.654.384Zm.748.436.654-.384.654.384-.654.374Zm.665,1.236-.654-.374.644-.374.654.374Zm.083-.81.654-.374.644.374-.644.384Zm.748.436.644-.384.665.384-.654.374Zm.748.426.644-.374.654.374-.654.374Zm.737.436.654-.384.654.384-.654.374Zm.748.426.654-.374.654.374-.644.384Zm.748.436.654-.384.654.384-.654.374Zm1.4.81-.654-.384.654-.374.654.374ZM13,43.571l-.27-.156-.156.021.332.2-.27.156.218-.021L13,43.685l.1.062.166-.021-.177-.1.623-.364-.239.031Zm.717-.312-.239.031-.478.28-.27-.156-.156.021.332.2-.27.156.218-.021L13,43.685l.1.062.166-.021-.177-.1Zm0,0-.239.031-.478.28-.27-.156-.156.021.332.2-.27.156.218-.021L13,43.685l.1.062.166-.021-.177-.1Zm0,0-.239.031-.478.28-.27-.156-.156.021.332.2-.27.156.218-.021L13,43.685l.1.062.166-.021-.177-.1Zm0,0-.239.031-.478.28-.27-.156-.156.021.332.2-.27.156.218-.021L13,43.685l.1.062.166-.021-.177-.1Z",
    transform: "translate(-3.22 -38.825)",
    fill: "#cad0dd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46544",
    "data-name": "Group 46544",
    transform: "translate(0.818 3.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54118",
    "data-name": "Path 54118",
    d: "M13.439,42.526l.033.073-.237.038-.747.119-.155.025-.9.144-.237.038.006-.088.046-.71,0-.04h-.12l-.543,0h-.135l-.542,0H9.639l-1.214,0H8.2v-.129l.006-.667v-.062H8.132l-1.207-.009-.267,0-1.234-.009-.241,0v-.03l.005-.1.032-.642,0-.063H5.146l-1.189-.006H3.8l-.007-.073h.184l1.157,0h.226l0,.127-.024.7.169.009,1.1.008h.371l1.142.009.228,0v.129l-.007.69v.039h.12l1.138-.006.368,0,.49,0h.135l.474,0h.328l0,.04,0,.034-.006.111-.037.635.274-.044.616-.1.155-.025,1.014-.163Z",
    transform: "translate(-3.79 -40.336)",
    fill: "#6eba6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46545",
    "data-name": "Group 46545",
    transform: "translate(7.615 5.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54119",
    "data-name": "Path 54119",
    d: "M9.111,42.423l-.588-.339V41.9l.543-.316h.12l0,.04-.636.37.59.341-.006.088.237-.038-.071.042.387.223-.159.015-.32-.185-.443.257-.221.021Z",
    transform: "translate(-8.523 -41.581)",
    fill: "#cad0dd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46546",
    "data-name": "Group 46546",
    transform: "translate(7.48 5.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54120",
    "data-name": "Path 54120",
    d: "M12.166,42.415l.02.073-.206.02-.862.082-.17.016-.517.049-.221.021-.374.035-.159.015-1.032.1-.206.02v-.077l-.007-.687V41.9l0-.316h.135v1.173l.016,0,.221-.021.763-.072.159-.015.642-.061.221-.021.25-.024.17-.016,1.113-.105Z",
    transform: "translate(-8.429 -41.583)",
    fill: "#ed435c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46547",
    "data-name": "Group 46547",
    transform: "translate(6.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54121",
    "data-name": "Path 54121",
    d: "M23.3,46.607l-.244.142L7.9,38l.244-.142Z",
    transform: "translate(-7.901 -37.859)",
    fill: "#cad0dd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46548",
    "data-name": "Group 46548",
    transform: "translate(6.023 0.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54122",
    "data-name": "Path 54122",
    d: "M22.81,46.89l-.244.142L7.414,38.283l.244-.142Z",
    transform: "translate(-7.414 -38.142)",
    fill: "#cad0dd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46549",
    "data-name": "Group 46549",
    transform: "translate(10.098 8.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54123",
    "data-name": "Path 54123",
    d: "M11.36,44.1l-.988.574-.119-.069.988-.574Z",
    transform: "translate(-10.252 -44.029)",
    fill: "#f9bb4a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46550",
    "data-name": "Group 46550",
    transform: "translate(10.49 8.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54124",
    "data-name": "Path 54124",
    d: "M12.6,43.863,10.644,45l-.119-.069,1.957-1.137Z",
    transform: "translate(-10.525 -43.794)",
    fill: "#f9bb4a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46551",
    "data-name": "Group 46551",
    transform: "translate(11.272 7.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54125",
    "data-name": "Path 54125",
    d: "M15,43.432,11.2,45.645l-.126-.073,3.808-2.213Z",
    transform: "translate(-11.07 -43.359)",
    fill: "#f9bb4a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46552",
    "data-name": "Group 46552",
    transform: "translate(12.87 10.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54126",
    "data-name": "Path 54126",
    d: "M13.3,45.216l-.988.574-.126-.073.988-.574Z",
    transform: "translate(-12.183 -45.143)",
    fill: "#8facfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46553",
    "data-name": "Group 46553",
    transform: "translate(13.262 10.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54127",
    "data-name": "Path 54127",
    d: "M14.538,44.981l-1.957,1.137-.126-.073,1.957-1.137Z",
    transform: "translate(-12.455 -44.908)",
    fill: "#8facfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46554",
    "data-name": "Group 46554",
    transform: "translate(9.057 6.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54128",
    "data-name": "Path 54128",
    d: "M14.128,42.47l-4.6,2.669,6.149,3.552,4.6-2.669Zm1.537,6L9.911,45.149l4.227-2.461L19.9,46.011Z",
    transform: "translate(-9.527 -42.47)",
    fill: "#cad0dd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46555",
    "data-name": "Group 46555",
    transform: "translate(10.881 7.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54129",
    "data-name": "Path 54129",
    d: "M14.184,43.5l-3.261,1.9-.126-.073,3.261-1.9Z",
    transform: "translate(-10.797 -43.423)",
    fill: "#f9bb4a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46556",
    "data-name": "Group 46556",
    transform: "translate(11.67 8.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54130",
    "data-name": "Path 54130",
    d: "M14.187,44.028l-2.721,1.581-.119-.069,2.721-1.581Z",
    transform: "translate(-11.347 -43.959)",
    fill: "#f9bb4a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46557",
    "data-name": "Group 46557",
    transform: "translate(12.061 9.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54131",
    "data-name": "Path 54131",
    d: "M13.583,44.54l-1.845,1.072-.119-.069,1.845-1.072Z",
    transform: "translate(-11.619 -44.471)",
    fill: "#f9bb4a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46558",
    "data-name": "Group 46558",
    transform: "translate(13.659 9.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54132",
    "data-name": "Path 54132",
    d: "M16.113,44.609l-3.261,1.9-.119-.069,3.261-1.9Z",
    transform: "translate(-12.732 -44.54)",
    fill: "#8facfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46559",
    "data-name": "Group 46559",
    transform: "translate(14.051 9.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54133",
    "data-name": "Path 54133",
    d: "M16.932,44.545l-3.808,2.213L13,46.689l3.808-2.213Z",
    transform: "translate(-13.005 -44.476)",
    fill: "#8facfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46560",
    "data-name": "Group 46560",
    transform: "translate(14.442 10.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54134",
    "data-name": "Path 54134",
    d: "M16.124,45.146,13.4,46.727l-.126-.073L16,45.074Z",
    transform: "translate(-13.277 -45.074)",
    fill: "#8facfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46561",
    "data-name": "Group 46561",
    transform: "translate(14.833 11.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54135",
    "data-name": "Path 54135",
    d: "M15.52,45.658,13.676,46.73l-.126-.073,1.845-1.072Z",
    transform: "translate(-13.55 -45.585)",
    fill: "#8facfc"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46570",
    "data-name": "Group 46570",
    transform: "translate(16.797 5.702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46565",
    "data-name": "Group 46565",
    transform: "translate(6.94 5.272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54136",
    "data-name": "Path 54136",
    d: "M21.381,40.674a9.134,9.134,0,0,1-3.37.8L18,39.713a4.9,4.9,0,0,0,1.23-.281Z",
    transform: "translate(-18 -39.432)",
    fill: "#ddaf9b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46566",
    "data-name": "Group 46566",
    transform: "translate(8.93 3.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54137",
    "data-name": "Path 54137",
    d: "M23.107,38.514a3.193,3.193,0,0,1-1.586,2.154l-2.135-1.233a1.71,1.71,0,0,0,.7-.917Z",
    transform: "translate(-19.386 -38.514)",
    fill: "#ed435c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46567",
    "data-name": "Group 46567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54138",
    "data-name": "Path 54138",
    d: "M19.105,35.761l.01,1.747c-1.672.1-2.952.917-2.946,1.912a1.691,1.691,0,0,0,.986,1.362,4.539,4.539,0,0,0,1.982.549l.01,1.748a8.912,8.912,0,0,1-4.105-1.068,3.186,3.186,0,0,1-1.874-2.591c-.011-1.938,2.623-3.546,5.938-3.659Z",
    transform: "translate(-13.167 -35.761)",
    fill: "#576cfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46568",
    "data-name": "Group 46568",
    transform: "translate(9.359 1.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54139",
    "data-name": "Path 54139",
    d: "M21.866,36.86a2.9,2.9,0,0,1,1.107,1.786H19.957a1.475,1.475,0,0,0-.272-.519Z",
    transform: "translate(-19.685 -36.86)",
    fill: "#75ca75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46569",
    "data-name": "Group 46569",
    transform: "translate(6.909 0.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54140",
    "data-name": "Path 54140",
    d: "M21.957,36.874l-2.121,1.233-.075-.052a4.459,4.459,0,0,0-1.772-.532l-.01-1.756a8.918,8.918,0,0,1,3.9,1.06Z",
    transform: "translate(-17.979 -35.767)",
    fill: "#f9bb4a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46585",
    "data-name": "Group 46585",
    transform: "translate(0.406 17.823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46582",
    "data-name": "Group 46582",
    transform: "translate(10.355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46573",
    "data-name": "Group 46573",
    transform: "translate(3.483 5.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46572",
    "data-name": "Group 46572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54141",
    "data-name": "Path 54141",
    d: "M18.017,18.148a14.526,14.526,0,0,1,6.584,11.4c-.012,4.183-2.987,5.879-6.627,3.777a14.54,14.54,0,0,1-6.584-11.4C11.4,17.733,14.377,16.046,18.017,18.148ZM17.98,31.319c2.675,1.545,4.863.3,4.872-2.777a10.7,10.7,0,0,0-4.84-8.393c-2.683-1.549-4.871-.3-4.88,2.781a10.7,10.7,0,0,0,4.848,8.389",
    transform: "translate(-11.39 -17.244)",
    fill: "#ed435c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46574",
    "data-name": "Group 46574",
    transform: "translate(1.742 3.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54142",
    "data-name": "Path 54142",
    d: "M18.552,16.827c4.605,2.659,8.335,9.12,8.32,14.411S23.1,38.67,18.5,36.011s-8.335-9.129-8.32-14.412,3.769-7.431,8.375-4.772ZM18.5,34.01c3.64,2.1,6.616.406,6.627-3.777a14.526,14.526,0,0,0-6.584-11.4c-3.64-2.1-6.616-.415-6.627,3.777A14.54,14.54,0,0,0,18.5,34.01",
    transform: "translate(-10.177 -15.684)",
    fill: "#e8f1fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46576",
    "data-name": "Group 46576",
    transform: "translate(2.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46575",
    "data-name": "Group 46575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54143",
    "data-name": "Path 54143",
    d: "M29.978,32.234c-.012,3.17-1.131,5.407-2.937,6.463l-1.733,1.008c1.806-1.057,2.925-3.293,2.937-6.476.025-6.4-4.485-14.205-10.052-17.425-2.8-1.622-5.345-1.769-7.176-.7L12.75,14.1c1.831-1.069,4.362-.922,7.176.7C25.492,18.017,30,25.819,29.978,32.234Z",
    transform: "translate(-11.017 -13.412)",
    fill: "#f76d8e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46578",
    "data-name": "Group 46578",
    transform: "translate(0 1.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46577",
    "data-name": "Group 46577"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54144",
    "data-name": "Path 54144",
    d: "M19.086,15.5c5.57,3.216,10.075,11.018,10.056,17.427S24.591,41.912,19.02,38.7,8.946,27.678,8.964,21.278s4.544-9,10.122-5.777Zm-.06,21.195c4.605,2.659,8.36.51,8.375-4.773S23.686,20.17,19.08,17.511s-8.36-.519-8.375,4.772,3.715,11.753,8.32,14.412",
    transform: "translate(-8.964 -14.115)",
    fill: "#ed435c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46580",
    "data-name": "Group 46580",
    transform: "translate(6.967 9.984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46579",
    "data-name": "Group 46579"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54145",
    "data-name": "Path 54145",
    d: "M16.948,20.79c-1.718-.992-3.127-.189-3.133,1.785a6.866,6.866,0,0,0,3.112,5.382c1.718.992,3.119.194,3.125-1.781a6.866,6.866,0,0,0-3.1-5.386Z",
    transform: "translate(-13.815 -20.365)",
    fill: "#ed435c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46581",
    "data-name": "Group 46581",
    transform: "translate(5.225 7.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54146",
    "data-name": "Path 54146",
    d: "M17.483,19.469a10.7,10.7,0,0,1,4.84,8.393c-.009,3.074-2.2,4.321-4.872,2.777A10.7,10.7,0,0,1,12.6,22.25C12.611,19.167,14.8,17.92,17.483,19.469Zm-.026,9.169c1.718.992,3.119.194,3.125-1.781a6.866,6.866,0,0,0-3.1-5.386c-1.718-.992-3.127-.189-3.133,1.785a6.866,6.866,0,0,0,3.112,5.382",
    transform: "translate(-12.603 -18.804)",
    fill: "#e8f1fa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46584",
    "data-name": "Group 46584",
    transform: "translate(0 13.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46583",
    "data-name": "Group 46583"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54147",
    "data-name": "Path 54147",
    d: "M6.868,29.694l1.309,1.182,13.552-7.824c.256-.148.463-.02.464.264a1,1,0,0,1-.461.788L8.18,31.928l-1.3,2.706L1.767,37.587,3.41,34.16,1.753,32.647Z",
    transform: "translate(-1.753 -22.99)",
    fill: "#363a44"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46592",
    "data-name": "Group 46592",
    transform: "translate(34.636 17.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46586",
    "data-name": "Group 46586"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54148",
    "data-name": "Path 54148",
    d: "M28.155,14.691,28.112,29.7l-2.522-1.457.043-15.011Z",
    transform: "translate(-25.591 -13.234)",
    fill: "#37617b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46587",
    "data-name": "Group 46587",
    transform: "translate(4.974 6.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54149",
    "data-name": "Path 54149",
    d: "M31.615,18.953l-.033,11.769-2.527-1.46.033-11.769Z",
    transform: "translate(-29.055 -17.493)",
    fill: "#5b5e71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46588",
    "data-name": "Group 46588",
    transform: "translate(9.954 13.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54150",
    "data-name": "Path 54150",
    d: "M35.066,23.922l-.021,7.506-2.522-1.457.021-7.506Z",
    transform: "translate(-32.523 -22.465)",
    fill: "#6eba6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46589",
    "data-name": "Group 46589",
    transform: "translate(14.929 11.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54151",
    "data-name": "Path 54151",
    d: "M38.543,22.716l-.034,12.112-2.522-1.457.034-12.112Z",
    transform: "translate(-35.987 -21.259)",
    fill: "#4562ef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46590",
    "data-name": "Group 46590",
    transform: "translate(19.903 9.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54152",
    "data-name": "Path 54152",
    d: "M42.02,21.471l-.048,16.773-2.522-1.457L39.5,20.014Z",
    transform: "translate(-39.451 -20.014)",
    fill: "#efac41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46591",
    "data-name": "Group 46591",
    transform: "translate(24.878 8.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54153",
    "data-name": "Path 54153",
    d: "M45.5,20.618,45.437,41.49l-2.522-1.457.059-20.872Z",
    transform: "translate(-42.915 -19.161)",
    fill: "#ed435c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46627",
    "data-name": "Group 46627",
    transform: "translate(42.441 56.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46597",
    "data-name": "Group 46597",
    transform: "translate(0 1.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46596",
    "data-name": "Group 46596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46593",
    "data-name": "Group 46593",
    transform: "translate(8.817 5.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54154",
    "data-name": "Path 54154",
    d: "M45.927,45l0,.659-8.759,5.09,0-.659Z",
    transform: "translate(-37.166 -44.996)",
    fill: "#e5a03c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46594",
    "data-name": "Group 46594",
    transform: "translate(0 5.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54155",
    "data-name": "Path 54155",
    d: "M39.844,50.087l0,.659-8.817-5.09,0-.659Z",
    transform: "translate(-31.026 -44.997)",
    fill: "#efac41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46595",
    "data-name": "Group 46595",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54156",
    "data-name": "Path 54156",
    d: "M48.6,46.542l-8.759,5.09-8.817-5.09,8.759-5.09Z",
    transform: "translate(-31.027 -41.452)",
    fill: "#f9bb4a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46602",
    "data-name": "Group 46602",
    transform: "translate(0 1.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46601",
    "data-name": "Group 46601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46598",
    "data-name": "Group 46598",
    transform: "translate(8.817 5.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54157",
    "data-name": "Path 54157",
    d: "M45.927,44.541l0,.659-8.759,5.09,0-.659Z",
    transform: "translate(-37.166 -44.541)",
    fill: "#e63044"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46599",
    "data-name": "Group 46599",
    transform: "translate(0 5.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54158",
    "data-name": "Path 54158",
    d: "M39.844,49.631l0,.659L31.026,45.2l0-.659Z",
    transform: "translate(-31.026 -44.541)",
    fill: "#ed435c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46600",
    "data-name": "Group 46600",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54159",
    "data-name": "Path 54159",
    d: "M48.6,46.086l-8.759,5.09-8.817-5.09L39.786,41Z",
    transform: "translate(-31.027 -40.996)",
    fill: "#f25574"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46607",
    "data-name": "Group 46607",
    transform: "translate(0 0.654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46606",
    "data-name": "Group 46606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46603",
    "data-name": "Group 46603",
    transform: "translate(8.817 5.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54160",
    "data-name": "Path 54160",
    d: "M45.927,44.085l0,.659-8.759,5.09,0-.659Z",
    transform: "translate(-37.166 -44.085)",
    fill: "#65aa65"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46604",
    "data-name": "Group 46604",
    transform: "translate(0 5.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54161",
    "data-name": "Path 54161",
    d: "M39.844,49.176l0,.659-8.817-5.09,0-.659Z",
    transform: "translate(-31.026 -44.086)",
    fill: "#6eba6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46605",
    "data-name": "Group 46605",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54162",
    "data-name": "Path 54162",
    d: "M48.6,45.631l-8.759,5.09-8.817-5.09,8.759-5.09Z",
    transform: "translate(-31.027 -40.541)",
    fill: "#75ca75"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46626",
    "data-name": "Group 46626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46625",
    "data-name": "Group 46625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46608",
    "data-name": "Group 46608",
    transform: "translate(8.817 5.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54163",
    "data-name": "Path 54163",
    d: "M45.927,43.63l0,.659-8.759,5.09,0-.659Z",
    transform: "translate(-37.166 -43.63)",
    fill: "#3c5dd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46609",
    "data-name": "Group 46609",
    transform: "translate(0 5.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54164",
    "data-name": "Path 54164",
    d: "M39.844,48.72l0,.659-8.817-5.09,0-.659Z",
    transform: "translate(-31.026 -43.63)",
    fill: "#4562ef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46610",
    "data-name": "Group 46610",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54165",
    "data-name": "Path 54165",
    d: "M48.6,45.175l-8.759,5.09-8.817-5.09,8.759-5.09Z",
    transform: "translate(-31.027 -40.085)",
    fill: "#576cfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46624",
    "data-name": "Group 46624",
    transform: "translate(4.077 1.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46611",
    "data-name": "Group 46611",
    transform: "translate(4.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54166",
    "data-name": "Path 54166",
    d: "M39.246,42.031l-.533.309-2.041-1.178.533-.309Z",
    transform: "translate(-36.673 -40.853)",
    fill: "#3c5dd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46612",
    "data-name": "Group 46612",
    transform: "translate(7.803 3.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54167",
    "data-name": "Path 54167",
    d: "M41.885,44.635l-.538.313L39.3,43.766l.538-.313Z",
    transform: "translate(-39.299 -43.453)",
    fill: "#3c5dd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46619",
    "data-name": "Group 46619",
    transform: "translate(0 0.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46613",
    "data-name": "Group 46613",
    transform: "translate(2.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54168",
    "data-name": "Path 54168",
    d: "M38.315,42.574l-.538.313-2.041-1.178.538-.313Z",
    transform: "translate(-35.735 -41.395)",
    fill: "#3c5dd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46614",
    "data-name": "Group 46614",
    transform: "translate(1.346 0.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54169",
    "data-name": "Path 54169",
    d: "M37.376,43.118l-.533.309L34.8,42.249l.533-.309Z",
    transform: "translate(-34.802 -41.94)",
    fill: "#3c5dd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46615",
    "data-name": "Group 46615",
    transform: "translate(5.245 1.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54170",
    "data-name": "Path 54170",
    d: "M40.1,43.606l-.538.313-2.047-1.182.538-.313Z",
    transform: "translate(-37.517 -42.424)",
    fill: "#3c5dd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46616",
    "data-name": "Group 46616",
    transform: "translate(0 1.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54171",
    "data-name": "Path 54171",
    d: "M36.444,43.66l-.538.313-2.041-1.178.538-.313Z",
    transform: "translate(-33.865 -42.482)",
    fill: "#3c5dd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46617",
    "data-name": "Group 46617",
    transform: "translate(3.905 2.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54172",
    "data-name": "Path 54172",
    d: "M39.164,44.151l-.533.309-2.047-1.182.533-.309Z",
    transform: "translate(-36.584 -42.969)",
    fill: "#3c5dd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46618",
    "data-name": "Group 46618",
    transform: "translate(2.559 3.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54173",
    "data-name": "Path 54173",
    d: "M38.232,44.693l-.538.313-2.047-1.182.538-.313Z",
    transform: "translate(-35.647 -43.511)",
    fill: "#3c5dd6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46620",
    "data-name": "Group 46620",
    transform: "translate(6.59 1.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54174",
    "data-name": "Path 54174",
    d: "M40.426,42.712l-.533.309-1.439-.831.533-.309Z",
    transform: "translate(-38.454 -41.882)",
    fill: "#3c5dd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46621",
    "data-name": "Group 46621",
    transform: "translate(9.149 2.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54175",
    "data-name": "Path 54175",
    d: "M42.136,43.7l-.533.309-1.367-.789.533-.309Z",
    transform: "translate(-40.236 -42.91)",
    fill: "#3c5dd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46622",
    "data-name": "Group 46622",
    transform: "translate(5.118 5.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54176",
    "data-name": "Path 54176",
    d: "M40.014,45.722l-.538.313-2.047-1.182.538-.313Z",
    transform: "translate(-37.429 -44.54)",
    fill: "#3c5dd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46623",
    "data-name": "Group 46623",
    transform: "translate(6.463 4.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54177",
    "data-name": "Path 54177",
    d: "M40.946,45.179l-.533.309-2.047-1.182L38.9,44Z",
    transform: "translate(-38.366 -43.997)",
    fill: "#3c5dd6"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreBusiness);
export default __webpack_public_path__ + "static/media/explore-business.6c06fffa083070fa9856a90580c98a09.svg";
export { ForwardRef as ReactComponent };